var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "@/models/BaseModel";
import OfferModel from "@/models/loyalty/OfferModel";
import Formatter from "@/utils/Formatter";
import PaymentLoyaltyFlowModel from "./loyalty/PaymentLoyaltyFlowModel";
import DeliveryFlowModel from "./DeliveryFlowModel";
var FranchisorModel = /** @class */ (function (_super) {
    __extends(FranchisorModel, _super);
    function FranchisorModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.address = hydrated.address;
        _this.appDomain = hydrated.appDomain;
        _this.beaconProximityUUID = hydrated.beaconProximityUUID;
        _this.deliveryFlowModel = hydrated.deliveryFlowModel;
        _this.host = hydrated.host;
        _this.id = hydrated.id;
        _this.loyaltyAds = hydrated.loyaltyAds;
        _this.loyaltyFeedbackBonusOn = hydrated.loyaltyFeedbackBonusOn;
        _this.loyaltyFeedbackOn = hydrated.loyaltyFeedbackOn;
        _this.loyaltyFeedbacksPerVisit = hydrated.loyaltyFeedbacksPerVisit;
        _this.loyaltyPointsForPurchaseFactor = hydrated.loyaltyPointsForPurchaseFactor;
        _this.loyaltyPointsPerReward = hydrated.loyaltyPointsPerReward;
        _this.loyaltyPointsPriceFactor = hydrated.loyaltyPointsPriceFactor;
        _this.loyaltyProgramIcon = hydrated.loyaltyProgramIcon;
        _this.loyaltyProgramName = hydrated.loyaltyProgramName;
        _this.loyaltyProgramSlogan = hydrated.loyaltyProgramSlogan;
        _this.loyaltyRedemptionValidWindow = hydrated.loyaltyRedemptionValidWindow;
        _this.loyaltySignupReward = hydrated.loyaltySignupReward;
        _this.loyaltySignupRewardOn = hydrated.loyaltySignupRewardOn;
        _this.loyaltyType = hydrated.loyaltyType;
        _this.loyaltyVisitsPerReward = hydrated.loyaltyVisitsPerReward;
        _this.loyaltyVisitsReward = hydrated.loyaltyVisitsReward;
        _this.loyaltyVisitsRewardOn = hydrated.loyaltyVisitsRewardOn;
        _this.mobileScanProximityDistance = hydrated.mobileScanProximityDistance;
        _this.name = hydrated.name;
        _this.paymentLoyaltyFlowModel = hydrated.paymentLoyaltyFlowModel;
        _this.resellerBase = hydrated.resellerBase;
        return _this;
    }
    FranchisorModel.prototype.hydrate = function (data) {
        var hydrated = {};
        hydrated.address = data.address || "";
        hydrated.appDomain = data.app_domain || "";
        hydrated.beaconProximityUUID = data.beacon_proximityUUID || "";
        hydrated.deliveryFlowModel = new DeliveryFlowModel(data.delivery_flow_model);
        hydrated.host = data.host || "";
        hydrated.id = data.franchisor_base || "";
        hydrated.loyaltyAds = data.loyalty_ads;
        hydrated.loyaltyFeedbackBonusOn = data.loyalty_feedback_bonus_on;
        hydrated.loyaltyFeedbackOn = data.loyalty_feedback_on;
        hydrated.loyaltyFeedbacksPerVisit = data.loyalty_feedbacks_per_visit;
        hydrated.loyaltyPointsForPurchaseFactor = (data.loyalty_points_for_purchase_factor) ? parseFloat(data.loyalty_points_for_purchase_factor) : 0;
        hydrated.loyaltyPointsPerReward = data.loyalty_points_per_reward;
        hydrated.loyaltyPointsPriceFactor = data.loyalty_points_price_factor;
        hydrated.loyaltyProgramIcon = data.loyalty_program_icon;
        hydrated.loyaltyProgramName = data.loyalty_program_name;
        hydrated.loyaltyProgramSlogan = data.loyalty_program_slogan;
        hydrated.loyaltyRedemptionValidWindow = data.loyalty_redemption_valid_window;
        hydrated.loyaltySignupReward = (data.loyalty_signup_reward) ? Formatter.convertKeyCase(data.loyalty_signup_reward, "camelCase") : {};
        hydrated.loyaltySignupRewardOn = data.loyalty_signup_reward_on;
        hydrated.loyaltyType = (data.loyalty_type) ? parseInt(data.loyalty_type) : null;
        hydrated.loyaltyVisitsPerReward = data.loyalty_visits_per_reward;
        hydrated.loyaltyVisitsReward = (data.loyalty_visits_reward) ? new OfferModel(data.loyalty_visits_reward) : null;
        hydrated.loyaltyVisitsRewardOn = data.loyalty_visits_reward_on;
        hydrated.mobileScanProximityDistance = data.mobile_scan_proximity_distance;
        hydrated.name = data.name;
        hydrated.paymentLoyaltyFlowModel = (data.payment_loyalty_flow_model) ? new PaymentLoyaltyFlowModel(data.payment_loyalty_flow_model) : {};
        hydrated.resellerBase = data.reseller_base;
        return hydrated;
    };
    FranchisorModel.prototype.getGoogleMapsAPIKey = function () {
        var deliveryFlowModel = this.deliveryFlowModel;
        if (deliveryFlowModel) {
            var apiKey = deliveryFlowModel.googleMapsApiKey;
            if (apiKey) {
                return apiKey;
            }
        }
        return false;
    };
    return FranchisorModel;
}(BaseModel));
export default FranchisorModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/FranchisorModel.ts
// module id = null
// module chunks = 